import { Route } from './types';
// import Example from '@/views/casino/Example';

const casinoRoutes: Route[] = [
  // {
  //   path: '/casino-example',
  //   name: 'casino-example',
  //   component: Example,
  //   meta: {
  //     requiresAuth: true,
  //     requiresRoles: ['casino:operator', 'casino:user'],
  //   },
  // },
];

export default casinoRoutes;
